/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

export { COLOR_MODES, DEFAULT_COLOR, DEFAULT_LINEAR_GRADIENT, DEFAULT_SYSTEM_SWATCH_COLORS, GRADIENT_SLIDER_DEFAULT_WIDTH, SATURATION_PANEL_DEFAULT_HEIGHT, SATURATION_PANEL_DEFAULT_WIDTH, SLIDER_DEFAULT_WIDTH, TD_COLOR_USED_COLORS_MAX_SIZE } from '../_common/js/color-picker/constants.mjs';

var FORMATS = ["HEX", "RGB", "HSL", "HSV", "CMYK", "CSS"];

export { FORMATS };
//# sourceMappingURL=const.mjs.map
